import React from "react";

const SemiFooter = () => {
  return (
    <div data-aos="zoom-in" data-aos-duration="2000" className="w-9/12 mx-auto text-xs text-gray-700 py-10">
      <p>
        * Apple Card Monthly Installments (ACMI) is a 0% APR payment option
        available only in the U.S. to select at checkout for certain Apple
        products purchased at Apple Store locations, apple.com, the Apple Store
        app, or by calling 1-800-MY-APPLE and is subject to credit approval and
        credit limit. See support.apple.com/kb/HT211204 for more information
        about eligible products. Variable APRs for Apple Card other than ACMI
        range from 14.74% to 25.74% based on creditworthiness. Rates as of
        December 1, 2022. If you choose the pay‑in‑full or one‑time‑payment
        option for an ACMI‑eligible purchase instead of choosing ACMI as the
        payment option at checkout, that purchase will be subject to the
        variable APR assigned to your Apple Card. Taxes and shipping are not
        included in ACMI and are subject to your card’s variable APR. See the
        Apple Card Customer Agreement for more information. ACMI is not
        available for purchases made online at the following special stores:
        Apple Employee Purchase Plan; participating corporate Employee Purchase
        Programs; Apple at Work for small businesses; Government, and Veterans
        and Military Purchase Programs, or on refurbished devices. iPhone
        activation required on iPhone purchases made at an Apple Store with one
        of these national carriers: AT&T, Sprint, Verizon, or T‑Mobile.
      </p>
      <br />
      <p>
        ** Pricing includes a $30 connectivity discount that requires activation
        with AT&T, T‑Mobile, Sprint, or Verizon.
      </p>
      <ol className="list-decimal my-5">
        <li>
          Pricing for iPhone 14 and iPhone 14 Plus includes a $30 connectivity
          discount that requires activation with AT&T, T‑Mobile, Sprint, or
          Verizon. Available to qualified customers and requires 24‑month
          installment loan when you select Citizens One or Apple Card Monthly
          Installments (ACMI) as payment type at checkout at Apple. iPhone
          activation required with AT&T, T‑Mobile, Sprint, or Verizon for
          purchases made with ACMI at an Apple Store. Subject to credit approval
          and credit limit. Taxes and shipping are not included in ACMI and are
          subject to your card’s variable APR. Additional Apple Card Monthly
          Installments terms are in the Apple Card Customer Agreement.
          Additional iPhone Payments terms are here. ACMI is not available for
          purchases made online at special storefronts. The last month’s payment
          for each product will be the product's purchase price, less all other
          payments at the monthly payment amount.
        </li>
        <li>
          The display has rounded corners that follow a beautiful curved design,
          and these corners are within a standard rectangle. When measured as a
          standard rectangular shape, the screen is 5.42 inches (iPhone 13 mini,
          iPhone 12 mini), 5.85 inches (iPhone 11 Pro, iPhone XS, iPhone X),
          6.06 inches (iPhone 14, iPhone 13 Pro, iPhone 13, iPhone 12 Pro,
          iPhone 12, iPhone 11, iPhone XR), 6.12 inches (iPhone 14 Pro), 6.46
          inches (iPhone 11 Pro Max, iPhone XS Max), 6.68 inches (iPhone 14
          Plus, iPhone 13 Pro Max, iPhone 12 Pro Max), or 6.69 inches (iPhone 14
          Pro Max) diagonally. Actual viewable area is less.
        </li>
        <li>
          Service is included for free for two years with the activation of any
          iPhone 14 model. Connection and response times vary based on location,
          site conditions, and other factors. See apple.com/iphone-14 or
          apple.com/iphone-14-pro for more information.
        </li>
        <li>
          All battery claims depend on network configuration and many other
          factors; actual results will vary. Battery has limited recharge cycles
          and may eventually need to be replaced. Battery life and charge cycles
          vary by use and settings. See apple.com/batteries and
          apple.com/iphone/battery.html for more information.
        </li>
        <li>
          AT&T iPhone 14 Special Deal: Monthly price reflects net monthly
          payment, after application of AT&T trade‑in credit applied over 36
          months with purchase of an iPhone 14 Pro, iPhone 14 Pro Max, iPhone
          14, or iPhone 14 Plus and trade‑in of eligible smartphone. Receive
          credit with purchase of an iPhone 14, iPhone 14 Plus, iPhone 14 Pro,
          or iPhone 14 Pro Max of either $1000, $800, or $350 (based upon the
          model and condition of your trade‑in smartphone), max bill credits
          will not exceed the cost of the device. Requires upgrade of an
          existing line or activation of a new line and purchase of a new iPhone
          14, iPhone 14 Plus, iPhone 14 Pro, or iPhone 14 Pro Max on qualifying
          36 month 0% APR installment plan, subject to carrier credit
          qualification. AT&T Installment Plan with Next Up is not eligible for
          this promotion. $0 down for well qualified customers only, or down
          payment may be required and depends on a variety of factors. Tax on
          full retail price due at sale. Requires activation on eligible
          unlimited plan. If you cancel eligible wireless service, credits will
          stop and you will owe the remaining device balance. Activation/Upgrade
          Fee: $35. Trade in device may not be on existing installment plan.
          Bill credits are applied as a monthly credit over the 36 month
          installment plan. Credits start within 3 bills. Will receive catchup
          credits once credits start. Wireless line must be on an installment
          agreement, active, and in good standing for 30 days to qualify.
          Installment agreement starts when device is shipped. To get all
          credits, device must remain on agreement for entire term and you must
          keep eligible service on device for entire installment term.
          Limited‑time offer; subject to change. Limits: one trade‑in per
          qualifying purchase and one credit per line. May not be combinable
          with other offers, discounts, or credits. Purchase, financing, other
          limits, and restrictions apply. Price for iPhone 14 and iPhone 14 Plus
          includes $30 AT&T connectivity discount. Activation required.
        </li>
      </ol>
      <p>
        AT&T iPhone 13 Special Deal: Buy an iPhone 13 128 GB and get $550 in
        bill credits applied over 36 months. Buy an iPhone 13 256 GB and get
        $470 in bill credits applied over 36 months. Buy an iPhone 13 512 GB and
        get $490 in bill credits applied over 36 months. Requires upgrade of an
        existing line (or activation of a new line) and purchase on qualifying
        36‑month 0% APR installment plan, subject to carrier credit
        qualification. $0 down for well‑qualified customers only, or down
        payment may be required and depends on a variety of factors. Tax on full
        retail price due at sale. If you cancel eligible wireless service,
        credits will stop and you will owe the remaining device balance.
        Activation/Upgrade Fee: $35. Bill credits are applied as a monthly
        credit over the 36‑month installment plan. Credits start within 3 bills.
        Will receive catch‑up credits once credits start. Wireless line must be
        on an installment agreement, active, and in good standing for 30 days to
        qualify. Installment agreement starts when device is shipped. To get all
        credits, device must remain on agreement for entire term and you must
        keep eligible service on device for entire installment term.
        Limited‑time offer; subject to change. Limits: one credit per line. May
        not be combinable with other offers, discounts, or credits. Purchase,
        financing, other limits, and restrictions apply. Activation required.
      </p>
      <br />
      <p>
        AT&T iPhone SE Special Deal: Buy an iPhone SE 64 GB and get $250 in bill
        credits applied over 36 months. Buy an iPhone SE 128 GB and get $120 in
        bill credits applied over 36 months. Buy an iPhone SE 256 GB and get $40
        in bill credits applied over 36 months. Requires upgrade of an existing
        line (or activation of a new line) and purchase on qualifying 36‑month
        0% APR installment plan, subject to carrier credit qualification. $0
        down for well‑qualified customers only, or down payment may be required
        and depends on a variety of factors. Tax on full retail price due at
        sale. If you cancel eligible wireless service, credits will stop and you
        will owe the remaining device balance. Activation/Upgrade Fee: $35. Bill
        credits are applied as a monthly credit over the 36‑month installment
        plan. Credits start within 3 bills. Will receive catch‑up credits once
        credits start. Wireless line must be on an installment agreement,
        active, and in good standing for 30 days to qualify. Installment
        agreement starts when device is shipped. To get all credits, device must
        remain on agreement for entire term and you must keep eligible service
        on device for entire installment term. Limited‑time offer; subject to
        change. Limits: one credit per line. May not be combinable with other
        offers, discounts, or credits. Purchase, financing, other limits, and
        restrictions apply. Activation required.
      </p><br />
      <p>
        Sprint Special Deal: Sprint trade‑in credit in the form of a rebate with
        virtual prepaid card when you trade in a qualifying device. Limited‑time
        offer; subject to change. Requires activation on any Sprint data plan
        and submission of a promo code at promotions.t-mobile.com. $200 rebate
        via virtual prepaid Mastercard® Card, which you can use online or
        in‑store via accepted mobile payment apps; no cash access & expires in 6
        months from issuance. Card is issued by Sunrise Banks N.A., Member FDIC,
        pursuant to a license from Mastercard International Incorporated.
        Mastercard is a registered trademark of Mastercard International
        Incorporated. Use of this card constitutes acceptance of the terms and
        conditions stated in the Cardholder Agreement. Lines must be active and
        in good standing when card is issued. Allow up to 2 billing cycles after
        fulfillment of offer requirements. Max 4 per account offer/discounted
        devices/account. May not be combined with some offers or discounts.
        Sales tax may be assessed on full value of new iPhone. Requires trade‑in
        of an iPhone XR or newer in good condition, including iPhone SE (2nd
        generation). Must be at least 18 to trade in. Apple or its trade‑in
        partners reserve the right to refuse or limit any trade‑in transaction
        for any reason. In‑store trade‑in requires presentation of a valid,
        government‑issued photo ID (local law may require saving this
        information). In‑store promotion availability subject to local law;
        speak to a Specialist to learn more. Additional terms from Apple,
        Sprint, and Apple’s trade‑in partners may apply.
      </p><br/>
      <p>
        T‑Mobile iPhone 14 Special Deal: Monthly price reflects net monthly
        payment, after application of T‑Mobile trade‑in credit applied over 24
        months with purchase of an iPhone 14 Pro, iPhone 14 Pro Max, iPhone 14,
        or iPhone 14 Plus and trade‑in of eligible smartphone. Receive credit
        with purchase of an iPhone 14, iPhone 14 Plus, iPhone 14 Pro, or iPhone
        14 Pro Max of $400 or $200 (based upon the model and condition of your
        trade‑in smartphone) for customers on any eligible rate plan. Max bill
        credits will not exceed the cost of the device. Credit comprised of (i)
        Apple instant trade‑in credit at checkout and (ii) T‑Mobile monthly bill
        credits applied over 24 months. Customer must remain in the T‑Mobile
        Equipment Installment Program and on eligible rate plan for 24 months
        and remain in good standing to receive the full benefit of the bill
        credits; allow 2 bill cycles from valid submission and validation of
        trade‑in. Tax on pre‑credit price due at sale. Limited‑time offer;
        subject to change. Qualifying credit, data plan, and trade‑in in good
        condition required. Max 4 promotional offers on any iPhone per account.
        May not be combinable with some offers or discounts. Price for iPhone 14
        and iPhone 14 Plus includes $30 T‑Mobile connectivity discount.
        Activation required.
      </p><br/>
      <p>
        T‑Mobile iPhone 13 Special Deal: Monthly price reflects net monthly
        payment, after application of T‑Mobile trade‑in credit applied over 24
        months with purchase of an iPhone 13 or iPhone 13 mini and trade‑in of
        eligible smartphone. Receive credit with purchase of an iPhone 13 or
        iPhone 13 mini of $400 or $200 (based upon the model and condition of
        your trade‑in smartphone) for customers on any eligible rate plan. Max
        bill credits will not exceed the cost of the device. Credit comprised of
        (i) Apple connectivity trade‑in credit at checkout and (ii) T‑Mobile
        monthly bill credits applied over 24 months. Customer must remain in the
        T‑Mobile Equipment Installment Program and on eligible rate plan for 24
        months and remain in good standing to receive the full benefit of the
        bill credits; allow 2 bill cycles from valid submission and validation
        of trade in. Tax on pre‑credit price due at sale. Limited‑time offer;
        subject to change. Qualifying credit, data plan, and trade‑in in good
        condition required. Max 4 promotional offers on any iPhone per account.
        May not be combinable with some offers or discounts. Price for iPhone 13
        and iPhone 13 mini includes $30 T‑Mobile connectivity discount.
        Activation required.
      </p><br/>
      <p>
        Verizon iPhone 14 Special Deal: Monthly price reflects net monthly
        payment, after application of Verizon trade‑in credit applied over 36
        months with purchase of an iPhone 14 Pro, iPhone 14 Pro Max, iPhone 14,
        or iPhone 14 Plus with credit of $800 or $400 for customers on a Get
        More or One Unlimited plan (based upon the model and condition of your
        trade‑in smartphone); or $440 or $220 for customers on a Do More or Play
        More plan (based upon the model and condition of your trade‑in
        smartphone). Credit comprised of (i) Apple instant trade‑in credit at
        checkout and (ii) Verizon monthly bill credits applied over 36 months.
        Customer must remain in the Verizon Device Payment Program for 36 months
        to receive the full benefit of the Verizon bill credits. Bill credits
        may take 1‑2 bill cycles to appear. If it takes two cycles for bill
        credits to appear, you’ll see the credit for the first cycle on your
        second bill in addition to that month’s credit. Requires purchase and
        activation of a new iPhone 14, iPhone 14 Plus, iPhone 14 Pro, or iPhone
        14 Pro Max with the Verizon Device Payment Program at 0% APR for 36
        months, subject to carrier credit qualification, and iPhone availability
        and limits. Taxes and shipping not included in monthly price. Sales tax
        may be assessed on full value of new iPhone. Requires eligible unlimited
        service plan. Requires trade‑in of eligible device in eligible
        condition. Must be at least 18 to trade‑in. Apple or its trade‑in
        partners reserve the right to refuse or limit any trade‑in transaction
        for any reason. In‑store trade‑in requires presentation of a valid,
        government‑issued photo ID (local law may require saving this
        information). In‑store promotion availability subject to local law;
        speak to a Specialist to learn more. Limited‑time offer; subject to
        change. Additional terms from Apple, Verizon, and Apple’s trade‑in
        partners may apply. Price for iPhone 14 and iPhone 14 Plus includes $30
        Verizon connectivity discount. Activation required.
      </p><br/>
      <p>
        To access and use all the features of Apple Card, you must add Apple
        Card to Wallet on an iPhone or iPad with the latest version of iOS or
        iPadOS. Update to the latest version by going to Settings  General 
        Software Update. Tap Download and Install. Learn more about how Apple
        Card applications are evaluated at support.apple.com/kb/HT209218.
        Available for qualifying applicants in the United States. Apple Card is
        issued by Goldman Sachs Bank USA, Salt Lake City Branch. If you reside
        in the U.S. territories, please call Goldman Sachs at 877‑255‑5923 with
        questions about Apple Card.  Apple
      </p><br/>
    </div>
  );
};

export default SemiFooter;
